import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

const Popup = ({ children, className, isHidden, onClose }) => {
  return (
    <div
      className={["popup", className, `${!isHidden ? "popup--show" : ""}`].join(
        " "
      )}
    >
      <div className="popup_inner">
        <a
          href="/#"
          onClick={e => {
            e.preventDefault()
            onClose()
          }}
          className="popup_close"
        >
          Close
        </a>

        <div className="popup_container">{children}</div>
      </div>
    </div>
  )
}

Popup.defaultProps = {
  className: ""
}

Popup.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  className: propTypes.string,
  isHidden: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired
}

export default Popup
